<template>
<div class="full-wrapper pannel">
  <el-scrollbar :ref="scrollbarRef">
    <div class="full">
      <w-operation-state-info :params="params" :rsc-info="operationStateParams" :active="active" />
      <el-row>
        <div class="row">
          <el-col :md="12" :lg="12">
            <w-perf-widget :show-change-btn="false">
              <span slot="perfHeader">구성 정보</span>
              <div slot="perfBody">
                <el-col :md="24" :lg="12">
                  <table v-if="configInfoData.parentObjtypeId == 'RTU'" class="list-none-border">
                    <tr>
                      <th>센서명</th>
                      <td>{{ configInfoData.fmsSensorName }}</td>
                    </tr>
                    <tr>
                      <th>수집방식</th>
                      <td>{{ configInfoData.rscGetmethodName }}</td>
                    </tr>
                    <tr>
                      <th>RTU 정보</th>
                      <td>{{ configInfoData.rtuLabel }}</td>
                    </tr>
                    <tr>
                      <th>포트</th>
                      <td>{{ configInfoData.fmsSensorPort }}</td>
                    </tr>
                  </table>
                  <table v-else class="list-none-border">
                    <tr>
                      <th>센서명</th>
                      <td>{{ configInfoData.fmsSensorName }}</td>
                    </tr>
                    <tr>
                      <th>수집방식</th>
                      <td>{{ configInfoData.rscGetmethodName }}</td>
                    </tr>
                    <tr>
                      <th>IP</th>
                      <td>{{ configInfoData.ipaddress }}</td>
                    </tr>
                    <tr>
                      <th>포트</th>
                      <td>{{ configInfoData.fmsSensorPort }}</td>
                    </tr>
                  </table>
                </el-col>
                <el-col :md="24" :lg="12">
                  <table class="list-none-border">
                    <tr>
                      <th>센서타입</th>
                      <td>{{ configInfoData.objtypeName }}</td>
                    </tr>
                    <tr>
                      <th>관리자 (정/부)</th>
                      <td>{{ configInfoData.majorLabel }}</td>
                    </tr>
                    <tr>
                      <th></th>
                      <td>{{ configInfoData.minorLabel }}</td>
                    </tr>
                  </table>
                </el-col>
              </div>

              <!-- <el-row :gutter="10" slot="perfBody">
                  <el-col :span="12">
                    <el-form ref="form" size="mini" label-position="left">
                      <el-form-item label="그룹명" label-width="100px"><span></span></el-form-item>
                      <el-form-item label="센서명" label-width="100px"><span>{{ configInfoData.fmsSensorName }}</span></el-form-item>
                      <el-form-item label="RTU 정보" label-width="100px"><span>{{ configInfoData.parentObjName }}</span></el-form-item>
                      <el-form-item label="포트" label-width="100px"><span>{{ configInfoData.fmsSensorPort }}</span></el-form-item>
                    </el-form>
                  </el-col>
                  <el-col :span="12">
                    <el-form ref="form" size="mini" label-position="left">
                      <el-form-item label="센서타입" label-width="100px"><span>{{ configInfoData.ipaddress }}</span></el-form-item>
                      <el-form-item label="관리자 (정/부)" label-width="100px">
                        <span>{{ configInfoData.majorLabel }} / {{ configInfoData.minorLabel }}</span>
                      </el-form-item>
                    </el-form>
                  </el-col>
                </el-row> -->
              <div slot="perfFooter">
                <span>최근 변경시각: {{ configInfoData.checkDatetimeLabel }}</span>
              </div>
            </w-perf-widget>
          </el-col>
          <el-col :md="12" :lg="12">
            <w-event-info-widget :event-info-data="eventInfoData"></w-event-info-widget>
          </el-col>
          <!-- 센서별 성능정보 위젯 -->
          <component v-if="currentSensorWidget !== null" :is="currentSensorWidget" :active="active"></component>
        </div>
      </el-row>
    </div>
  </el-scrollbar>
  <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
</div>
</template>

<script>
import clone from 'lodash/clone';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import moment from 'moment';
import { mapGetters } from 'vuex';
import ScrollbarMixin from '@/mixins/scrollbar';
import { EMPTY_TEXT } from '@/utils/string';
import sensorApi from '@/api/performance/sensor/sensor';
import summaryApi from '@/api/performance/summary/summary-info';
import { getIntervalDatetimeParams } from '@/utils/date';
import WPerfWidget from '../components/PerfWidget';
import WOperationStateInfo from '../components/OperationStateInfo';
import WEventInfoWidget from '../components/EventInfoWidget';
import WPerfFupsView from './components/PerfFupsView';
import WPerfFthehygroView from './components/PerfFthehygroView';
import WPerfFthView from './components/PerfFthView';
import WPerfFtempView from './components/PerfFtempView';
import WPerfFwldsView from './components/PerfFwldsView';
import WPerfFfiredsView from './components/PerfFfiredsView';
import WPerfFsensorView from './components/PerfFsensorView';
import WPerfFvsbmsView from './components/PerfFvsbmsView';
import WPerfFgcuView from './components/PerfFgcuView';
import WPerfFrtView from './components/PerfFrtView';

export default {
  name: 'WPerformanceSensorSummary',
  mixins: [ScrollbarMixin],
  components: {
    WPerfWidget,
    WOperationStateInfo,
    WEventInfoWidget,
    WPerfFupsView, // UPS
    WPerfFthehygroView, // 항온항습기
    WPerfFthView, // 온습도 센서
    WPerfFtempView, // 선형온도 센서
    WPerfFwldsView, // 누수 센서
    WPerfFfiredsView, // 소방설비
    WPerfFsensorView, // 도어 센서
    WPerfFvsbmsView, // 분전반
    WPerfFgcuView, // 발전기
    WPerfFrtView, // 정류기
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      params: {
        managetypeId: 'FMS',
      },
      configInfoData: {},
      eventInfoData: {},
    };
  },
  computed: {
    currentSensorWidget() {
      if (this.active) {
        const sensorType = this.selectedNode.obj.objtypeId;
        return `WPerf${sensorType.substring(0, 1)}${sensorType.substring(1).toLowerCase()}View`;
      }
      return null;
    },
    operationStateParams() {
      const sensorType = this.selectedNode.obj.objtypeId;
      const rscId = sensorType === 'FTEMP' ? `${sensorType}_ALIVE` : `${sensorType.substring(1)}_ALIVE`;
      const params = {
        rsctypeId: `${sensorType}_RUNNINGSTATUS`,
        rscId,
        rscKey: '_',
      };
      return params;
    },
    ...mapGetters(['selectedNode']),
  },
  watch: {
    selectedNode: {
      handler(to) {
        if (!isEmpty(to) && this.active) {
          this.loadData();
        }
      },
      immediate: true,
    },
    active: {
      handler(to) {
        if (to) {
          this.loadData();
        }
      },
    },
  },
  mounted() {
    this.setScrollData();
  },
  methods: {
    getIntervalDatetimeParams,
    loadData() {
      if (this.active) {
        const startDatetime = this.getIntervalDatetimeParams(new Date(), 'hour', 12);
        Object.assign(this.params, {
          objId: this.selectedNode.obj.objId,
          objtypeId: this.selectedNode.obj.objtypeId,
          startDatetime,
        });
        this.loadConfInfoView();
        this.loadEventInfo();
      }
    },
    /**
     * 구성 정보 load
     * @author jeee12
     */
    loadConfInfoView() {
      sensorApi
        .getSensorConfigurationInfo({
          objId: this.selectedNode.obj.objId,
        })
        .then((response) => {
          if (response.data.success) {
            const configInfo = response.data.data;
            let majorLabel = EMPTY_TEXT;
            let minorLabel = EMPTY_TEXT;

            if (configInfo.majorName) {
              majorLabel = configInfo.majorDepartment ? `[${configInfo.majorDepartment}]${configInfo.majorName}` : `[${EMPTY_TEXT}]${configInfo.majorName}`;
            }
            if (configInfo.minorName) {
              minorLabel = configInfo.minorDepartment ? `[${configInfo.minorDepartment}]${configInfo.minorName}` : `[${EMPTY_TEXT}]${configInfo.minorName}`;
            }
            configInfo.majorLabel = majorLabel;
            configInfo.minorLabel = minorLabel;
            configInfo.checkDatetimeLabel = !isNil(configInfo.checkDatetime) ? moment(configInfo.checkDatetime).format('YYYY년 MM월 DD일 HH:mm:ss') : EMPTY_TEXT;
            this.configInfoData = configInfo;
          }
        });
    },
    /**
     * 이벤트 정보 조회
     * @author jeee12
     */
    loadEventInfo() {
      const params = clone(this.params);
      params.endDatetime = new Date().getTime();

      summaryApi.getSummaryEventInfo(params).then((response) => {
        if (response.data.success) {
          this.eventInfoData = response.data.data;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/summary/sensor/index.vue